import { Fun, Updater } from 'widgets-for-react'
import {
  CategoriesFilterState,
  initialCategoriesFilterState,
} from '../../filters/categoriesFilter/categoriesFilterState'
import { CategoriesFilter, TopFilters } from '../../filters/filtersUtils'
import {
  TopFiltersState,
  initialTopFiltersState,
} from '../../filters/topFilters/topFiltersState'
import {
  PaginationState,
  initialPaginationState,
} from '../../pagination/paginationState'
import {
  ComponentSaverState,
  componentSaverStateUpdaters,
  initialComponentSaverState,
} from '../componentSaver/componentSaverState'
import {
  ComponentTeasersState,
  initialComponentTeasersState,
} from '../componentTeasers/componentTeasersState'
import { getComponentTeasers, getComponentsCount } from './componentOverviewApi'
import { componentsPerPage } from './componentOverviewWidget'

export type ComponentOverviewState = {
  topFiltersState: TopFiltersState
  categoriesFilterState: CategoriesFilterState
  componentTeasersState: ComponentTeasersState
  componentSaverState: ComponentSaverState
  paginationState: PaginationState
}

export const initialComponentOverviewState = (
  page: number,
  categoriesFilter: CategoriesFilter,
  topFilters: TopFilters
): ComponentOverviewState => {
  const filters = {
    categoriesFilter: categoriesFilter,
    topFilters: topFilters,
  }
  return {
    topFiltersState: initialTopFiltersState(topFilters),
    categoriesFilterState: initialCategoriesFilterState(categoriesFilter),
    componentTeasersState: initialComponentTeasersState(() =>
      getComponentTeasers(componentsPerPage, page - 1, filters)
    ),
    componentSaverState: initialComponentSaverState,
    paginationState: initialPaginationState(() => getComponentsCount(filters)),
  }
}

export const componentOverviewStateUpdaters = {
  topFiltersStateUpdater:
    (updater: Updater<TopFiltersState>) =>
    (state: ComponentOverviewState): ComponentOverviewState => ({
      ...state,
      topFiltersState: updater(state.topFiltersState),
    }),
  categoriesFilterStateUpdater:
    (updater: Updater<CategoriesFilterState>) =>
    (state: ComponentOverviewState): ComponentOverviewState => ({
      ...state,
      categoriesFilterState: updater(state.categoriesFilterState),
    }),
  componentTeasersStateUpdater:
    (
      updater: Fun<
        ComponentTeasersState,
        ComponentTeasersState & { saveComponentId: number | 'none' }
      >
    ) =>
    (state: ComponentOverviewState): ComponentOverviewState => {
      const newState = updater(state.componentTeasersState)
      return {
        ...state,
        componentTeasersState: newState,
        componentSaverState:
          newState.saveComponentId == 'none'
            ? state.componentSaverState
            : componentSaverStateUpdaters.startSavingUpdater(
                newState.saveComponentId
              )(state.componentSaverState),
      }
    },
  componentSaverStateUpdater:
    (
      updater: Fun<
        ComponentSaverState,
        ComponentSaverState & { reloadCollections?: boolean }
      >
    ) =>
    (
      state: ComponentOverviewState
    ): ComponentOverviewState & { reloadCollections?: boolean } => {
      const { reloadCollections, ...newState } = updater(
        state.componentSaverState
      )
      return {
        ...state,
        componentSaverState: newState,
        reloadCollections: reloadCollections,
      }
    },
  paginationStateUpdater:
    (updater: Updater<PaginationState>) =>
    (state: ComponentOverviewState): ComponentOverviewState => ({
      ...state,
      paginationState: updater(state.paginationState),
    }),
}
